import { useApp } from '../../context/AppContext';
import { Button } from '../ui/button';
import { ScrollArea } from '../ui/scroll-area';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

export const RightDrawer = () => {
  const { rightDrawerOpen, rightDrawerContent, closeRightDrawer } = useApp();

  return (
    <>
      {/* Backdrop */}
      {rightDrawerOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 animate-fade-in"
          onClick={closeRightDrawer}
          data-testid="drawer-backdrop"
        />
      )}

      {/* Drawer */}
      <div
        className={cn('right-drawer', rightDrawerOpen && 'open')}
        data-testid="right-drawer"
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-slate-200">
            <h3 className="text-lg font-semibold text-slate-900">Quick View</h3>
            <Button
              variant="ghost"
              size="icon"
              onClick={closeRightDrawer}
              className="text-slate-500 hover:text-slate-900"
              data-testid="close-drawer-btn"
            >
              <X className="w-5 h-5" />
            </Button>
          </div>

          {/* Content */}
          <ScrollArea className="flex-1 p-4">
            {rightDrawerContent}
          </ScrollArea>
        </div>
      </div>
    </>
  );
};

export default RightDrawer;
